
import { ContaBancaria } from "@/types/financeiro";

// Empty mock data for demonstration purposes - in a real app these would come from an API
export const contasMock: ContaBancaria[] = [];

// Mock data for the cash flow chart - this would be replaced by real data from database
export const mockFluxoCaixaData = [
  { dia: '01', receitas: 0, despesas: 0 },
  { dia: '05', receitas: 0, despesas: 0 },
  { dia: '10', receitas: 0, despesas: 0 },
  { dia: '15', receitas: 0, despesas: 0 },
  { dia: '20', receitas: 0, despesas: 0 },
  { dia: '25', receitas: 0, despesas: 0 },
  { dia: '30', receitas: 0, despesas: 0 },
];
